import { render, staticRenderFns } from "./leftTabsTableView.vue?vue&type=template&id=0ccc1597&scoped=true"
import script from "./leftTabsTableView.vue?vue&type=script&lang=js"
export * from "./leftTabsTableView.vue?vue&type=script&lang=js"
import style0 from "./leftTabsTableView.vue?vue&type=style&index=0&id=0ccc1597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc1597",
  null
  
)

export default component.exports